import classNames from "classnames";

export const RoundPoly = ({text, bgColor}) => {
    return (
         <div className="rect-poly">
            <div 
                className="rectangle"
                style={{backgroundColor: bgColor}}
            >
            <div className="rect-text" style={{backgroundColor: bgColor}}>{text}</div>
            </div>

            <div className={classNames("polygon-shape",'fwd')} style={{backgroundColor: bgColor}} />
        </div>
    )
}